import React from 'react';
import BackButton from '../components/BackButton';
import RadicalAuditability from '../components/RadicalAuditability';

function RadicalAuditabilityPage() {
  return (
    <>
      <BackButton />
      <RadicalAuditability />
    </>
  );
}

export default RadicalAuditabilityPage;
